import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetReveniReturnInfoSchema, GetReveniReturnResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetReveniReturnResponseDataSchema>>

export function useReveniSearchReturnMutation() {
  return useMutation({
    mutationFn: async (data: z.infer<typeof GetReveniReturnInfoSchema>) => {
      return axios
        .post<Response>(`/integrations/reveni/search`, data)
        .then((response) => response.data.data)
    },
  })
}
